import { Typography } from "@circle-react-shared/uikit/Typography";

interface TitleProps {
  oldTitle?: string;
  prefix?: string;
  suffix?: string;
  title: string;
}

export const Title = ({ prefix, oldTitle, title, suffix }: TitleProps) => (
  <span className="inline-block whitespace-nowrap">
    {prefix && (
      <span className="pr-1">
        <Typography.LabelSm weight="normal">{prefix}</Typography.LabelSm>
      </span>
    )}
    <span>
      {oldTitle && (
        <Typography.LabelXs weight="normal">
          <span
            className="text-tertiary pr-1 align-text-bottom line-through"
            data-testid="old-price"
          >
            {oldTitle}
          </span>
        </Typography.LabelXs>
      )}
      <Typography.LabelMd weight="semibold" data-testid="current-price">
        {title}
      </Typography.LabelMd>
    </span>
    {suffix && (
      <span className="pl-1">
        <Typography.LabelSm weight="normal">{suffix}</Typography.LabelSm>
      </span>
    )}
  </span>
);
